import React, { ReactNode } from 'react';
import './Card.module.css';

interface CardProps {
    id?: string;
    children: ReactNode;
    borderRadius?: number;
    // CLASSNAMES:
    // "collapsed" - removes background color and box-shadow
    // "animate-press" - reduces box-shadow when element is pressed
    className?: string;
    testId?: string;
}

const CardComponent = (props: CardProps) => {
    return (
        <div className={`card${props.className ? ` ${props.className}` : ''}`} data-testid={props.testId} id={props.id} style={{ borderRadius: props.borderRadius }}>
            {props.children}
        </div>
    );
};

export const Card = React.memo(CardComponent);
